/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import DialogContent from 'components/DialogContent.jsx';
import EmailForm from 'user/components/EmailForm.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

class SetupEmail extends React.Component<{}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  onSave = () => {
    this.context.router.push('/');
  };

  render() {
    return (
      <DialogContent
        size="small"
        full
        title={'What is your email address?'}
        subtext={'This will be your primary email address for Remind.'}>
        <BoxBody divided>
          <EmailForm onSave={this.onSave} />
        </BoxBody>
      </DialogContent>
    );
  }
}

export default SetupEmail;
